<div id="app" class="{{layoutClassName}}" [class.with-debug-bar]="!debugBar()?.hidden()">
  <ng-content select="[menu]"></ng-content>

  <section id="content">
    <ng-content select="[content-top-bar]"></ng-content>

    <main id="main" scrolledByContainer>
      <div class="container">
        <div class="row justify-content-center">
          <ng-content select="[content-main]"></ng-content>
        </div>
      </div>
    </main>

    @if (withThemeSelector) {
      <side-panel
        (clickOutside)="closePanels()"
        exclude="#top-bar .btn-notifications, #top-bar"
        [open]="themesIsOpened">
        @if (themesIsOpened) {
          <div class="theme-switcher-panel">
            <h2 class="m-3" translate="App.Themes.Title"></h2>
            <theme-switcher (selectTheme)="useTheme($event)"/>
          </div>
        }
      </side-panel>
    }
  </section>

  <section class="app-wide-sidepanel" [class.open]="isAIChatOpen$ | async">
    @if (isAIChatOpenOnce$ | async) {
      <ai-chat-box />
    }
  </section>
</div>

@if ((isAIChatOpen$ | async) === false) {
  <debug-bar/>
}

@if (withContactForm) {
  <contact-form>
    <button
      before-contact-form-button
      class="ai-chat-button btn btn-primary"
      [ngbTooltip]="'App.AIChat.Title' | translate"
      data-cy="AIChat"
      (click)="toggleAIChat()"
      >{{ 'App.AIChat.Name' | translate }} <i class="far fa-sparkles"></i></button>
    </contact-form>
  }
